import React from 'react';

export const UserIcon = ({ width = 32, height = 32, color = "#CDA16A", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                className={className}
                d="M16 13.3333C18.9455 13.3333 21.3333 10.9455 21.3333 7.99999C21.3333 5.05447 18.9455 2.66666 16 2.66666C13.0544 2.66666 10.6666 5.05447 10.6666 7.99999C10.6666 10.9455 13.0544 13.3333 16 13.3333Z"
                fill={color}
            />
            <path
                className={className}
                d="M26.6667 23.3333C26.6667 26.6467 26.6667 29.3333 16 29.3333C5.33337 29.3333 5.33337 26.6467 5.33337 23.3333C5.33337 20.02 10.1094 17.3333 16 17.3333C21.8907 17.3333 26.6667 20.02 26.6667 23.3333Z"
                fill={color}
            />
        </svg>
    );
};